import React, { Component } from 'react';
import { checkLogin, exitAdmin } from './scripts/SessionHelper';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Layout } from './components/Layout';
import Home from './components/Home';
import { Contacts } from './components/Contacts';
import { AdminLogin } from './components/AdminLogin';
import { UploadItem } from './components/UploadItem';
import { Comments } from './components/Comments';
import { AddComments } from './components/AddComments';
import { AboutCompany } from './components/AboutCompany';
import { AdminComments } from './components/AdminComments';
import { Gallery } from './components/Gallery';
import { Product } from './components/Product';
import { MyWorks } from './components/MyWorks';
import { ChangePassword } from './components/ChangePassword';
import { Actions } from './components/Actions';

import './styles/css/index.css';

const queryClient = new QueryClient();

export default class App extends Component {
  componentDidMount() {
    this.checkAdmin();
  }

  async checkAdmin() {
    if (checkLogin()) {
      try {
        const response = await fetch('api/DataforDB/CheckAdmin');
        if (!response.ok) throw new Error('Server error');

        const data = await response.json();
        if (!data) exitAdmin();

      } catch (error) {
        console.error('Admin check error:', error);
      }
    }
  }

  render() {
    const validate = checkLogin();

    return (
      <QueryClientProvider client={queryClient}>
        <Layout>
          <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/catalog" element={<Gallery />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/adminpanel" element={<AdminLogin />} />

            {validate && (
              <>
                <Route path="/uploadItem" element={<UploadItem />} />
                <Route path="/productEdit/:id" element={<UploadItem />} />
                <Route path="/adminComments" element={<AdminComments />} />
                <Route path="/changePassword" element={<ChangePassword />} />
                <Route path="/actions" element={<Actions />} />
              </>
            )}

            <Route path="/comments" element={<Comments />} />
            <Route path="/addComments" element={<AddComments />} />
            <Route path="/about" element={<AboutCompany />} />
            <Route path="/works" element={<MyWorks />} />

          </Routes>
        </Layout>
      </QueryClientProvider>
    );
  }
}